import React from "react";
import { getCloudinaryImageUrl } from "../../../utils/getCloudinaryImageUrl";

const PackageCard = React.memo(({ pkg, openBookingModal }) => {
    const hasDiscount =
        pkg.discountedPrice && pkg.discountedPrice < pkg.price;

    const discountPct = hasDiscount
        ? Math.round(((pkg.price - pkg.discountedPrice) / pkg.price) * 100)
        : 0;

    return (
        <div
            onClick={(e) => {
                openBookingModal(pkg)
            }}
            className="group bg-white rounded-[20px] h-full overflow-hidden border border-[#9b3a1f]/[0.08] flex flex-col transition-all duration-300 ease-out  hover:shadow-xl cursor-pointer transform will-change-transform">

            {/* Image */}
            <div className="relative h-48 overflow-hidden bg-[#f0e6e0]">
                <img
                    srcSet={`
                        ${getCloudinaryImageUrl(pkg.banner, { width: 400 })} 400w, 
                        ${getCloudinaryImageUrl(pkg.banner, { width: 600 })} 600w, 
                        ${getCloudinaryImageUrl(pkg.banner, { width: 800 })} 800w 
                      `}
                    sizes="(max-width: 640px) 400px, (max-width: 1024px) 600px, 800px"
                    alt={pkg.name}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.03]"
                />

                {pkg?.category?.trim() && (
                    <span className="absolute top-3 left-3 text-[9px] uppercase tracking-widest font-medium bg-white/90 text-[#9b3a1f] px-2.5 py-1 rounded-full border border-[#9b3a1f]/15 backdrop-blur-sm">
                        {pkg.category}
                    </span>
                )}

                {hasDiscount && (
                    <span className="absolute top-3 right-3 text-[10px] font-medium bg-[#1a0f0a] text-[#f5e8e2] px-2.5 py-1 rounded-full">
                        {discountPct}% off
                    </span>
                )}

                <div className="absolute bottom-0 left-0 right-0 h-14 bg-gradient-to-t from-white/70 to-transparent" />
            </div>

            {/* Body */}
            <div className="p-5 flex flex-col flex-1 gap-3">
                <h3 className="font-philosopher text-lg font-semibold text-[#1a0f0a] leading-snug line-clamp-2 group-hover:text-[#9b3a1f] transition-colors duration-200">
                    {pkg.name}
                </h3>

                <div className="w-7 h-px bg-[#9b3a1f] opacity-40" />

                <ul className="flex flex-col gap-1.5 flex-1">
                    {pkg.services?.slice(0, 3).map((service, i) => (
                        <li
                            key={i}
                            className="flex items-center gap-2 text-[12px] text-[#6b5147] font-light"
                        >
                            <span className="w-1.5 h-1.5 rounded-full bg-[#c07a62] flex-shrink-0" />
                            <span className="line-clamp-1">{service}</span>
                        </li>
                    ))}

                    {pkg.services?.length > 3 && (
                        <li className="text-[11px]  text-[#9b3a1f] font-medium ">
                            +{pkg.services.length - 3} more
                        </li>
                    )}
                </ul>

                {/* Footer */}
                <div className="flex items-center justify-between pt-3 border-t border-[#9b3a1f]/[0.08]">
                    <div className="flex items-baseline gap-1.5">
                        <span className="font-philosopher text-2xl font-semibold text-[#9b3a1f] leading-none">
                            ₹
                            {(hasDiscount ? pkg.discountedPrice : pkg.price).toLocaleString(
                                "en-IN"
                            )}
                        </span>

                        {hasDiscount && (
                            <span className="text-[11px] text-[#b8a39c] line-through font-light">
                                ₹{pkg.price.toLocaleString("en-IN")}
                            </span>
                        )}
                    </div>

                    <button

                        onClick={(e) => {
                            openBookingModal(pkg)
                            e.stopPropagation();
                        }}
                        className="flex items-center gap-1.5 bg-[#2B1A14] hover:bg-primaryBtnHoverColor text-[#f5e8e2] text-[10px] uppercase tracking-widest font-medium px-4 py-2 rounded-full transition-all duration-200 hover:scale-105 whitespace-nowrap transform-gpu"
                    >
                        Book

                    </button>
                </div>
            </div>
        </div>
    );
});


export const PackageCardSkeleton = () => {
    return (
        <div className="bg-white rounded-[20px] overflow-hidden border border-[#9b3a1f]/[0.08] flex flex-col animate-pulse">

            {/* Image */}
            <div className="h-48 bg-[#f0e6e0]" />

            {/* Body */}
            <div className="p-5 flex flex-col gap-3">

                {/* Title */}
                <div className="h-5 w-3/4 bg-[#f0e6e0] rounded" />

                {/* Divider */}
                <div className="w-7 h-px bg-[#e6d5cd]" />

                {/* Services */}
                <div className="flex flex-col gap-2">
                    <div className="h-3 w-full bg-[#f0e6e0] rounded" />
                    <div className="h-3 w-5/6 bg-[#f0e6e0] rounded" />
                    <div className="h-3 w-4/6 bg-[#f0e6e0] rounded" />
                </div>

                {/* Footer */}
                <div className="flex items-center justify-between pt-3 border-t border-[#9b3a1f]/[0.08]">
                    <div className="h-6 w-16 bg-[#f0e6e0] rounded" />
                    <div className="h-8 w-20 bg-[#f0e6e0] rounded-full" />
                </div>

            </div>
        </div>
    );
};

export default PackageCard;